// config.js
const config = {
  // baseUrl: "http://127.0.0.1:9900",
  // imageUrl: "http://127.0.0.1:8800/data/uploads",

  // baseUrl: "https://dptfontendapi.msg-demo.com",
  // imageUrl: "https://dptadminapi.msg-demo.com/data/uploads",

  baseUrl: "https://dptfontendapi.msgwddemo.in",
  imageUrl: "https://dptadminapi.msgwddemo.in/data/uploads",
};  
export default config;
